import styled from "@emotion/styled"
import { durationSm, easeInOut, spacingStaticMd } from "@porsche-design-system/components-react/emotion"
import { shouldForwardProp } from "src/common/shouldForwardProp"
import { StageList } from "../stageList/StageList"

interface VehicleListStageListProps {
	$filterScrollable?: boolean
	$withFilters: boolean
}

export const VehicleListStageList = styled(StageList, { shouldForwardProp })<VehicleListStageListProps>`
	display: grid;
	grid-column-gap: 0; /* handled via margin and wider column for cleaner and simpler transition */
	align-items: start;
	--filter-width: 350px;
	grid-template-columns: ${({ $withFilters }) =>
		$withFilters ? `calc(var(--filter-width) + ${spacingStaticMd}) minmax(0, 1fr)` : "0px minmax(0, 1fr)"};
	transition: grid-template-columns ${durationSm} ${easeInOut};

	/* active filters */
	> *:nth-of-type(1) {
		grid-column: 1 / -1;
	}

	/* filters */
	> *:nth-of-type(2) {
		position: sticky;
		${({ $filterScrollable }) => !$filterScrollable && "z-index: 1;"}
		top: 116px; /* spacingStaticMd + 100px for height of sticky header */
		${({ $filterScrollable }) =>
			$filterScrollable &&
			`
			overflow-y: auto;
			max-height: calc(100vh - 2 * ${spacingStaticMd} - 100px); /* 100px for sticky header */
		`}
		scrollbar-gutter: stable;
		min-width: var(--filter-width);
		box-sizing: border-box;
		margin-inline-end: ${spacingStaticMd};
		justify-self: end;
		opacity: 0;
		transition: opacity ${durationSm} ${easeInOut};
		${({ $withFilters }) => $withFilters && "opacity: 1;"}
	}

	${({ $filterScrollable }) =>
		!$filterScrollable &&
		`
		/* list */
		> *:nth-of-type(3) {
			position: unset;
		}
	`}
`
